import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import {
    IReduxState,
    StepCounterType,
    DeviceType,
    SingleColorType,
    ComponentStageType,
} from '../types';
import { nextStep, goToStep } from '../redux/actions/step';
import { setBackgroundColor } from '../redux/actions/backgroundColor';

import { InstructionsView } from '../components/Instructions';

import { colors } from '../constants';
import { pushToDataLayer } from '../utils';

interface IProps {
    deviceType: DeviceType;
    totalSteps: number;
    onNextStep(counter: StepCounterType): void;
    goToStepConnect(stepNumber: number, counter: StepCounterType): void;
    setBackgroundColorConnect(color: SingleColorType): void;
    onCloseButtonClick?(): void;
}

// tslint:disable-next-line:max-func-body-length
const BaseInstructions: React.FC<IProps> = ({
    totalSteps,
    onNextStep,
    goToStepConnect,
    setBackgroundColorConnect,
    onCloseButtonClick,
}) => {
    const [componentStage, setComponentStage] = useState<ComponentStageType>(
        'enter'
    );
    // Reset to step 1 after component unmount
    useEffect(
        () => () => {
            goToStepConnect(1, 'instructions');
        },
        []
    );

    useEffect(() => {
        setBackgroundColorConnect(colors.greenBg);
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    const handleNextButtonClick = () => {
        pushToDataLayer('Intro: De online oogcheck');
        setComponentStage('exit');
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleNextButtonClick();

            return;
        }
    };

    const handleFinalAnimationRest = () => {
        if (componentStage === 'exit') onNextStep('main');
    };

    return (
        <InstructionsView
            componentStage={componentStage}
            totalSteps={totalSteps}
            onNextButtonClick={handleNextButtonClick}
            onCloseButtonClick={onCloseButtonClick}
            onFinalAnimationRest={handleFinalAnimationRest}
        />
    );
};

const mapStateToProps = (state: IReduxState) => ({
    deviceType: state.deviceType,
});

const mapDispatchToProps = {
    onNextStep: nextStep,
    goToStepConnect: goToStep,
    setBackgroundColorConnect: setBackgroundColor,
};

export const Instructions = connect(
    mapStateToProps,
    mapDispatchToProps
)(BaseInstructions);
